<template>
  <div>
    <h1>Lights Shadows</h1>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "SEO Test | Lights Shadows",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "이 페이지는 babylonejs의 Lights & Shadows 연습입니다.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
